export const PRODUCTOPTION_LOADING = "PRODUCTOPTION_LOADING";
export const PRODUCTOPTION_RESET = "PRODUCTOPTION_RESET";
export const GET_PRODUCTOPTION = "GET_PRODUCTOPTION";
export const GET_PRODUCTOPTION_SUCCESS = "GET_PRODUCTOPTION_SUCCESS";
export const GET_PRODUCTOPTION_FAIL = "GET_PRODUCTOPTION_FAIL";
export const DELETE_PRODUCTOPTION = "DELETE_PRODUCTOPTION"
export const DELETE_PRODUCTOPTION_SUCCESS = "DELETE_PRODUCTOPTION_SUCCESS"
export const DELETE_PRODUCTOPTION_FAIL = "DELETE_PRODUCTOPTION_FAIL"
export const UPDATE_PRODUCTOPTION = "UPDATE_PRODUCTOPTION"
export const UPDATE_PRODUCTOPTION_SUCCESS = "UPDATE_PRODUCTOPTION_SUCCESS"
export const UPDATE_PRODUCTOPTION_FAIL = "UPDATE_PRODUCTOPTION_FAIL"
export const ADD_NEW_PRODUCTOPTION = "ADD_NEW_PRODUCTOPTION"
export const ADD_PRODUCTOPTION_SUCCESS = "ADD_PRODUCTOPTION_SUCCESS"
export const ADD_PRODUCTOPTION_FAIL = "ADD_PRODUCTOPTION_FAIL"